import '@upside/flux-ui/lib/styles/global.css';
import '@upside/react-components/lib/styles/global.css';

import initialiseShell from './shell';

initialiseShell().catch(() => {
  // eslint-disable-next-line no-console
  console.error('Error initialising the shell');
});
